import { Columns, breakpoints, Column, Heading, Stack } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { useMediaQuery } from 'usehooks-ts';
import PopularRoute from './PopularRoute';
import PopularRoutesCarousel from './PopularRoutesCarousel';

const PopularRoutes = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const isNarrowViewport = useMediaQuery(`(max-width: ${breakpoints._560})`);

  const destinations: string[] = p('SeoComponent.PopularRoutes.Destinations');
  const popularRoutes = destinations.map((destination) => {
    const header = t(`SeoComponent.PopularRoutes.DestinationName.Header.${destination}`);
    const link = t(`SeoComponent.PopularRoutes.DestinationName.Link.${destination}`);
    return { header, link, destination };
  });

  return (
    <div data-testid="link-component">
      <Stack spacing={16}>
        <Heading level={2}>{t('SeoComponent.PopularRoutes.Header')}</Heading>
        {isNarrowViewport ? (
          <PopularRoutesCarousel data-testid="carousel">
            {popularRoutes.map(({ destination, header, link }) => {
              return (
                <PopularRoute
                  destination={destination}
                  header={header}
                  key={destination}
                  link={link}
                />
              );
            })}
          </PopularRoutesCarousel>
        ) : (
          <Columns data-testid="popular-routes-columns" spacing={16}>
            {popularRoutes.map(({ destination, header, link }) => {
              return (
                <Column
                  data-testid="popular-route-column"
                  key={destination}
                  width={{
                    [breakpoints._1440]: '1/4',
                    [breakpoints._1024]: '2/6',
                    [breakpoints._360]: '2/4',
                  }}
                >
                  <PopularRoute
                    destination={destination}
                    header={header}
                    key={destination}
                    link={link}
                  />
                </Column>
              );
            })}
          </Columns>
        )}
      </Stack>
    </div>
  );
};

export default PopularRoutes;
